var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.customer ? _c('v-row', {
    staticClass: "mt-0",
    attrs: {
      "value": 0
    }
  }, [_c('v-col', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "cols": "12",
      "lg": "12"
    }
  }, [_c('header', {
    staticClass: "theme--light v-navigation-drawer elevation-1",
    staticStyle: {
      "height": "50px",
      "border-radius": "5px",
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "v-toolbar__content",
    staticStyle: {
      "height": "50px",
      "padding": "25px"
    }
  }, [_c('div', {
    staticClass: "v-toolbar__title"
  }, [_c('h4', {
    staticClass: "black--text"
  }, [_vm._v("Claims Owner Information")])])])]), _c('ValidationObserver', {
    ref: "updateCustomerObserver"
  }, [_c('v-card', {
    staticClass: "v-sheet"
  }, [_c('v-card-text', {
    staticClass: "text--primary pa-4"
  }, [_c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    staticClass: "py-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Firstname",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.customer.firstName,
      callback: function ($$v) {
        _vm.$set(_vm.customer, "firstName", $$v);
      },
      expression: "customer.firstName"
    }
  })], 1), _c('v-col', {
    staticClass: "py-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Lastname",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.customer.lastName,
      callback: function ($$v) {
        _vm.$set(_vm.customer, "lastName", $$v);
      },
      expression: "customer.lastName"
    }
  })], 1), _c('v-col', {
    staticClass: "py-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Phone",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.customer.phone,
      callback: function ($$v) {
        _vm.$set(_vm.customer, "phone", $$v);
      },
      expression: "customer.phone"
    }
  })], 1), _c('v-col', {
    staticClass: "py-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "email",
      "rules": "email"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var errors = _ref.errors;
        return [_c('v-text-field', {
          attrs: {
            "label": "E-Mail",
            "error-messages": errors,
            "outlined": "",
            "dense": "",
            "hide-details": "auto",
            "required": ""
          },
          model: {
            value: _vm.customer.email,
            callback: function ($$v) {
              _vm.$set(_vm.customer, "email", $$v);
            },
            expression: "customer.email"
          }
        })];
      }
    }], null, false, 1059977210)
  })], 1), _c('v-col', {
    staticClass: "py-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('ValidationProvider', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref2) {
        var errors = _ref2.errors;
        return [_c('v-text-field', {
          attrs: {
            "label": "Account Number",
            "error-messages": errors,
            "outlined": "",
            "dense": "",
            "hide-details": "auto",
            "required": ""
          },
          model: {
            value: _vm.customer.payment.accountNumber,
            callback: function ($$v) {
              _vm.$set(_vm.customer.payment, "accountNumber", $$v);
            },
            expression: "customer.payment.accountNumber"
          }
        })];
      }
    }], null, false, 2993152483)
  })], 1), _c('v-col', {
    staticClass: "py-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('ValidationProvider', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref3) {
        var errors = _ref3.errors;
        return [_c('v-text-field', {
          attrs: {
            "label": "Bank Name",
            "error-messages": errors,
            "outlined": "",
            "dense": "",
            "hide-details": "auto",
            "required": ""
          },
          model: {
            value: _vm.customer.payment.bankName,
            callback: function ($$v) {
              _vm.$set(_vm.customer.payment, "bankName", $$v);
            },
            expression: "customer.payment.bankName"
          }
        })];
      }
    }], null, false, 2625331747)
  })], 1), _c('v-col', {
    staticClass: "py-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('ValidationProvider', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref4) {
        var errors = _ref4.errors;
        return [_c('v-text-field', {
          attrs: {
            "label": "Clearing Number",
            "error-messages": errors,
            "outlined": "",
            "dense": "",
            "hide-details": "auto",
            "required": ""
          },
          model: {
            value: _vm.customer.payment.clearingNumber,
            callback: function ($$v) {
              _vm.$set(_vm.customer.payment, "clearingNumber", $$v);
            },
            expression: "customer.payment.clearingNumber"
          }
        })];
      }
    }], null, false, 284950691)
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticClass: "accent",
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "click": function ($event) {
        return _vm.update();
      }
    }
  }, [_vm._v("Update")])], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }